import { Box, Chip, Paper, Stack, Tooltip, Typography } from "@mui/material"
import { useApiService } from "../hooks/Api/useApiService"
import { useEffect, useRef, useState } from "react"
import T from "../hooks/Language/T"
import { useNavigate } from "react-router-dom"
import useTranslationSharie from "../hooks/Language/useTranslation"
import SimilarSkill from "./SimilarSkill"

const SavedSkills = () => {
  const [selected_skill, setSelectedSkill] = useState(null)
  const [skills, setSkills] = useState([])
  const navigate = useNavigate()
  const { postData } = useApiService()
  const t = useTranslationSharie()

  useEffect(() => {
    postData("skills/getsavedskills", { user_name: localStorage.getItem("user") }).then((data) => {
      if (data?.skills) setSkills([...data.skills, ...data.groups])
    })
  }, [])

  const handleViewGroup = (group) => {
    navigate("/groups", {
      state: {
        skill: group,
      },
    })
  }

  const handleSkillClick = (skill) => {
    if (skill === selected_skill) setSelectedSkill(null) // Deselect if already selected
    else setSelectedSkill(skill) // Set the selected skill
  }

  return (
    <Paper
      elevation={4}
      sx={{
        p: 3,
        borderRadius: "0.8rem",
        width: "100%", // Set full width of the parent container
        mx: "auto", // Center horizontally
        mt: 4,
        m: 4,
        overflow: "hidden", // Prevents overflow if content exceeds width
        position: "relative", // Needed for the minimize icon to position correctly
      }}
    >
      <Stack alignItems={"center"} direction='row' spacing={1} flexWrap='wrap'>
        <Typography variant='body2' color='text.secondary' sx={{ padding: "1rem" }}>
          {t("Saved Skills")}
        </Typography>
        {skills?.map((skill, index) => (
          <Tooltip key={index} title={skill.max_participants ? t("Group") : t("Skill")}>
            <Chip
              label={skill.name}
              color={skill.max_participants ? "secondary" : "primary"}
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                p: 0.5,
                cursor: "pointer",
                maxWidth: "150px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              onClick={() =>
                skill.max_participants ? handleViewGroup(skill) : handleSkillClick(skill)
              }
            />
          </Tooltip>
        ))}
      </Stack>
      {selected_skill && (
        <Box sx={{ mt: 2 }}>
          <SimilarSkill skill={selected_skill} key={selected_skill?.name} />
        </Box>
      )}
    </Paper>
  )
}
export default SavedSkills
